import { createSelector } from 'reselect';
import { fetchData } from './DataFetcher';
import { generateQueryString } from '../ParameterUtilities.ts';
import { getEntities } from '../../../Resources/EntityData';
import { isBlank } from 'utils/isBlank';

export function fetchDataIfNeeded(fetchingHash, props) {
  return (dispatch, getState) => {
    const data = fetchingHash.selector(getState(), props);
    if (isBlank(data)) {
      return dispatch(fetchData(fetchingHash, props));
    }
    return new Promise((resolve) => resolve());
  };
}

export function forceFetchData(fetchingHash, props) {
  return (dispatch) => dispatch(fetchData(fetchingHash, props));
}

export const getCompositeSchemaKey = (paginationData) => generateQueryString(paginationData);

export const isCompositeSchemaKeyPresent = (namespace) =>
  createSelector(
    getEntities,
    (_state, { paginationData } = {}) => getCompositeSchemaKey(paginationData),
    (entities, schemaKey) => entities[namespace]?.hasOwnProperty(schemaKey) || false
  );
